import { Button, Card, Dialog } from '@mui/material';
import * as React from 'react';
import { useSelector } from 'react-redux';
import { ContentsSelectors } from '@data/contents/Contents.selectors';
import useAppDispatch from '@data/useAppDispatch';
import { unpublishContents } from '@data/contents/Contents.thunk';
import { LoadingButton } from '@mui/lab';
import { Content } from '@data/contents/Contents.model';

export interface ContentUnpublishModalProps {
  selectedContentIds: string[];
  onClose: () => void;
  resetSelectedContents: () => void;
}

export const ContentUnpublishModal = (props: ContentUnpublishModalProps) => {
  const { selectedContentIds, onClose, resetSelectedContents } = props;

  const filteredList = useSelector((state: any) =>
    ContentsSelectors.contents.selectByIds(state, selectedContentIds),
  ) as Content[];

  const [isLoading, setIsLoading] = React.useState(false);

  const dispatch = useAppDispatch();
  const handleUnpublish = () => {
    setIsLoading(true);
    // Dispatch an action to unpublish the selected contents
    dispatch(
      unpublishContents({
        contentIds: selectedContentIds,
      }),
    ).then((_) => {
      resetSelectedContents();
      setIsLoading(false);
      onClose();
    });
    onClose();
  };

  return (
    <Dialog open>
      <Card className="pt-10 w-[371px] flex-col-center p-[20px]">
        <div className="w-full text-left h4 text-brand-primary">
          Unpublishing Content
        </div>
        <div className="w-full max-h-full mt-2 h4 text-brand-secondary">
          Are you sure you want revert these contents to a draft?
          <ul className="mb-8" style={{ maxHeight: '10rem', overflow: 'auto' }}>
            {filteredList.map((content) => (
              <li key={content.id} className="flex mt-2">
                <span
                  style={{
                    marginTop: '0.5rem',
                    fontSize: '6px',
                    marginRight: '0.5rem',
                    marginLeft: '1rem',
                  }}
                >
                  {'\u2B24'}
                </span>
                <span>{content.title}</span>
              </li>
            ))}
          </ul>
          <span className="font-bold subtitle1">
            Any Series will be removed from all interactions and no longer
            visible in the Discover section.{' '}
            <span className="text-error">All progress will be reset.</span>
          </span>
        </div>
        <div className="flex justify-center mt-[30px]">
          <Button
            onClick={onClose}
            variant="outlined"
            color="primary"
            className="w-[130px] h-[40px] !mr-[10px] !ml-[10px]"
          >
            Cancel
          </Button>
          <LoadingButton
            onClick={handleUnpublish}
            className="w-[130px] h-[40px] !mr-[10px] !ml-[10px]"
            variant="contained"
            color="primary"
            loading={isLoading}
          >
            Confirm
          </LoadingButton>
        </div>
      </Card>
    </Dialog>
  );
};
